<template lang="pug">
  div
    transition(name='fade')
      router-view
</template>

<script>
export default {
  name: 'MeetingView',
};
</script>
